module.exports = {
    carDataInteriores: () => {
        return [
            {
                "NUEVO HB20 INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/HB20 AT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-0.654 0.674 1.246",
                            "Rotation":"79.608 -90 0",
                            "Scale":"0.05 0.05",
                            "Text":['Control de mandos de retrovisores y vidrios eléctricos con función de antiaprisionamiento en el vidrio del conductor'],
                            "Image":require('./../UI/Bullets/NuevaHB20/Controldemandos.webp')
                        },
                        {
                            "Position":"-3.826 -0.829 3.608",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Detalles y acabados que ofrecen un mayor refinamiento como el volante interactivo con comandos de voz.'],
                            "Image":require('./../UI/Bullets/NuevaHB20/volante.webp')
                        },
                        {
                            "Position":"-3.826 0.066 0.077",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Cámara de reversa.'],
                            "Image":require('./../UI/Bullets/NuevaHB20/Pantallatactil.webp')
                        },
                        {
                            "Position":"-3.826 0.066 -2.223",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['6 bolsas de aire (airbags): 2 Frontales + 2 Tipo Cortina + 2 Laterales de Tórax'],
                            "Image":require('./../UI/Bullets/NuevaHB20/airbags.webp')
                        },
                        {
                            "Position":"-3.826 -1.631 0.020",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Centro de entretenimiento con pantalla flotante de 8" táctil, con Apple CarPlay y Android Auto, conectividad inalámbrica, reconocimiento de voz y aire acondicionado.'],
                            "Image":require('./../UI/Bullets/NuevaHB20/Conexioninhalambria.webp')
                        },
                        {
                            "Position":"-3.826 -2.533 0.020",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":[' Puerto de 12V de carga convencional + USB tipo A + USB tipo C'],
                            "Image":require('./../UI/Bullets/NuevaHB20/cargarapida.webp')
                        },
                        {
                            "Position":"-2.336 -2.533 0.020",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión mecánica y automática de 6 velocidades.'],
                            //"Image":require('./../UI/Bullets/NuevaHB20/Controldemandos.webp')
                        },
                        {
                            "Position":"0.955 -2.533 -0.171",
                            "Rotation":"76.971 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Puerto de 12V de carga USB tipo C en la parte posterior.'],
                            "Image":require('./../UI/Bullets/NuevaHB20S/cargatrasera.webp')
                        }
                    ],
                    "BulletsOn": [/*
                        {
                            "Position":"-3.826 -0.309 0.930",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }*/
                    ]
                },

                "NUEVO HB20 INTERIOR ON": {
                    "Image": require('./../assets/interioresParticulares/HB20 Premium AT_Night.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.674 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Centro de entretenimiento con pantalla flotante touch de 8" con conectividad Car Play y Android Auto.', '• Bluetooth con reconocimiento de voz + USB.', '• Parlantes: 2 en puerta delanteras + 2 en puertas traseras'],
                            "Image":require('./../UI/Bullets/01_HB20 - Advance/HB20-Advance_Radio.webp')
                        },
                        {
                            "Position":"-3.826 -0.014 2.287",
                            "Rotation":"45 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Volante interactivo con controles en el mando"],
                            "Image":require('./../UI/Bullets/01_HB20 - Advance/HB20-Advance_Volante.webp')
                        },
                        {
                            "Position":"-3.826 -0.599 2.5763",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Airbags: 2 Frontales (conductor + copiloto) + 2 laterales."],
                        },
                        {
                            "Position":"-2.346 -0.599 3.510",
                            "Rotation":"70.760 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Vidrios eléctricos (x4) con función de un toque subida/bajada y antiaprisionamiento en el vidrio del conductor."],
                            "Image":require('./../UI/Bullets/01_HB20 - Advance/HB20-Advance_ControlVidrios.webp')
                        },
                        {
                            "Position":"4.795 0.781 3.510",
                            "Rotation":"9.666 -159.837 0",
                            "Scale":"0.15 0.15",
                            "Text":["Seguro para niños en puertas traseras."]
                        },
                        {
                            "Position":"4.795 0.528 -1.445",
                            "Rotation":"9.666 116.702 0",
                            "Scale":"0.15 0.15",
                            "Text":["• Sistema Isofix." ,"• Anclaje para sillas de bebé."]
                        },
                        {
                            "Position":"-3.826 -2.683 -0.273",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Versión caja mecánica o automática de 6 velocidades"],
                        }
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-3.826 -0.309 0.930",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "NUEVO HB20S INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/HB20S AT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-0.654 0.674 1.246",
                            "Rotation":"79.608 -90 0",
                            "Scale":"0.05 0.05",
                            "Text":['Control de mandos de retrovisores y vidrios eléctricos con función de antiaprisionamiento en el vidrio del conductor'],
                            "Image":require('./../UI/Bullets/NuevaHB20S/Controldemandos.webp')
                        },
                        {
                            "Position":"-3.826 -0.829 3.608",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Detalles y acabados que ofrecen un mayor refinamiento como el volante interactivo con comandos de voz.'],
                            "Image":require('./../UI/Bullets/NuevaHB20S/volante.webp')
                        },
                        {
                            "Position":"-3.826 0.066 0.077",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Cámara de reversa.'],
                            "Image":require('./../UI/Bullets/NuevaHB20S/Pantallatactil.webp')
                        },
                        {
                            "Position":"-3.826 0.066 -2.223",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['6 bolsas de aire (airbags): 2 Frontales + 2 Tipo Cortina + 2 Laterales de Tórax'],
                            "Image":require('./../UI/Bullets/NuevaHB20S/airbags.webp')
                        },
                        {
                            "Position":"-3.826 -1.631 0.020",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Centro de entretenimiento con pantalla flotante de 8" táctil, con Apple CarPlay y Android Auto, conectividad inalámbrica, reconocimiento de voz y aire acondicionado.'],
                            "Image":require('./../UI/Bullets/NuevaHB20S/Conexioninhalambria.webp')
                        },
                        {
                            "Position":"-3.826 -2.533 0.020",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":[' Puerto de 12V de carga convencional + USB tipo A + USB tipo C'],
                            "Image":require('./../UI/Bullets/NuevaHB20S/cargarapida.webp')
                        },
                        {
                            "Position":"-2.336 -2.533 0.020",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión mecánica y automática de 6 velocidades.'],
                            //"Image":require('./../UI/Bullets/NuevaHB20/Controldemandos.webp')
                        },
                        {
                            "Position":"0.955 -2.533 0.225",
                            "Rotation":"76.971 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Puerto de 12V de carga USB tipo C en la parte posterior'],
                            "Image":require('./../UI/Bullets/NuevaHB20S/cargatrasera.webp')
                        }
                    ],
                    "BulletsOn": [ 
                       
                    ]
                },

                "NUEVO HB20S INTERIOR ON": {
                    "Image": require('./../assets/interioresParticulares/HB20S Premium AT_Night.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 1.124 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Centro de entretenimiento con pantalla flotante touch de 8" con conectividad Car Play y Android Auto.', '• Bluetooth con reconocimiento de voz + USB.', '• Parlantes: 2 en puerta delanteras + 2 en puertas traseras'],
                            "Image":require('./../UI/Bullets/01_HB20 - Advance/HB20-Advance_Radio.webp')
                        },
                        {
                            "Position":"-3.826 0.402 2.617",
                            "Rotation":"45 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Volante interactivo con controles en el mando"],
                            "Image":require('./../UI/Bullets/01_HB20 - Advance/HB20-Advance_Volante.webp')
                        },
                        {
                            "Position":"-3.826 -0.329 2.965",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Airbags: 2 Frontales (conductor + copiloto) + 2 laterales."],
                        },
                        {
                            "Position":"-2.857 -0.599 4.198",
                            "Rotation":"70.760 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Vidrios eléctricos (x4) con función de un toque subida/bajada y antiaprisionamiento en el vidrio del conductor."],
                            "Image":require('./../UI/Bullets/01_HB20 - Advance/HB20-Advance_ControlVidrios.webp')
                        },
                        {
                            "Position":"4.933 0.265 3.510",
                            "Rotation":"9.666 -159.837 0",
                            "Scale":"0.15 0.15",
                            "Text":["Seguro para niños en puertas traseras."]
                        },
                        {
                            "Position":"4.795 0.378 -1.101",
                            "Rotation":"9.666 116.702 0",
                            "Scale":"0.15 0.15",
                            "Text":["• Sistema Isofix.", "• Anclaje para sillas de bebé."]
                        },
                        {
                            "Position":"-4.148 -2.737 0.334",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Disponible en caja automática o mecánica de 6 velocidades."],
                        }
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-3.826 0.357 1.052",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "HB20X ADVANCE INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/HB20X Advance AT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.674 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Centro de entretenimiento con pantalla flotante touch de 8" con conectividad Car Play y Android Auto.', '• Bluetooth con reconocimiento de voz + USB.', '• Parlantes: 2 en puerta delanteras + 2 en puertas traseras'],
                            "Image":require('./../UI/Bullets/05_HB20X Advance/HB20X-Advance_ Radio.webp')
                        },
                        {
                            "Position":"-3.826 0.013 2.334",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Volante interactivo con controles de mando'],
                            "Image":require('./../UI/Bullets/05_HB20X Advance/HB20X-Advance_Volante.webp')
                        },
                        {
                            "Position":"-3.826 -3.074 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Caja automática de 6 velocidades'],
                        },
                        {
                            "Position":"4.933 1.1581 3.510",
                            "Rotation":"9.666 -159.837 0",
                            "Scale":"0.15 0.15",
                            "Text":["Seguro para niños en puertas traseras."]
                        },
                        {
                            "Position":"4.795 0.923 -0.711",
                            "Rotation":"9.666 116.702 0",
                            "Scale":"0.15 0.15",
                            "Text":["• Sistema Isofix.", "Anclaje para sillas de bebé."]
                        },
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-3.826 -0.309 0.930",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "HB20X ADVANCE INTERIOR ON": {
                    "Image": require('./../assets/interioresParticulares/HB20X Advance AT_Night.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.674 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Centro de entretenimiento con pantalla flotante touch de 8" con conectividad Car Play y Android Auto.', '• Bluetooth con reconocimiento de voz + USB.', '• Parlantes: 2 en puerta delanteras + 2 en puertas traseras'],
                            "Image":require('./../UI/Bullets/05_HB20X Advance/HB20X-Advance_ Radio.webp')
                        },
                        {
                            "Position":"-3.826 0.013 2.334",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Volante interactivo con controles de mando'],
                            "Image":require('./../UI/Bullets/05_HB20X Advance/HB20X-Advance_Volante.webp')
                        },
                        {
                            "Position":"-3.826 -3.074 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Caja automática de 6 velocidades'],
                        },
                        {
                            "Position":"4.933 1.1581 3.510",
                            "Rotation":"9.666 -159.837 0",
                            "Scale":"0.15 0.15",
                            "Text":["Seguro para niños en puertas traseras."]
                        },
                        {
                            "Position":"4.795 0.923 -0.711",
                            "Rotation":"9.666 116.702 0",
                            "Scale":"0.15 0.15",
                            "Text":["• Sistema Isofix.", "Anclaje para sillas de bebé."]
                        },
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-3.826 -0.309 0.930",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "TUCSON NX4 PREMIUM INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/Tucson 2022 AT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.233 -2.636",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Bolsas de aire (6 airbgas) : +Laterales, Torax + Cortina'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_AIRBAG.webp')
                        },
                        {
                            "Position":"-3.826 -1.499 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Aire acondicionado automático dual con ducto de ventilación trasera'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_AIRE.webp')
                        },
                        {
                            "Position":"-1.953 5.294 -0.024",
                            "Rotation":"16.645 90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Techo panorámico con apertura de un solo toque'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_TECHO.webp')
                        },
                        {
                            "Position":"-3.826 -0.577 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Radio con pantalla táctil de 10,25', '• USB', '• Bluetooth.','• CarPlay & Android Auto', '• Control de A/C'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_VOLANTE-RADIO.webp')
                        },
                        {
                            "Position":"3.931 0.674 -0.0344",
                            "Rotation":"0 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Asientos segunda fila abatible 40 : 20 : 40' ,'• Función abatible remota'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_FUNCION ABATIBLE REMOTA .webp')
                        },
                        {
                            "Position":"-3.826 -1.015 2.066",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Control crucero'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_CONTROL CRUCERO.webp')
                        },
                        {
                            "Position":"-3.826 -3.974 0.605",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión: 6 velocidades AT'],
                        },
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-3.826 -0.834 1.065",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "TUCSON NX4 PREMIUM INTERIOR ON": {
                    "Image": require('./../assets/interioresParticulares/Tucson 2022 AT_Night.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.233 -2.636",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Bolsas de aire (6 airbgas) : +Laterales, Torax + Cortina'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_AIRBAG.webp')
                        },
                        {
                            "Position":"-3.826 -1.499 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Aire acondicionado automático dual con ducto de ventilación trasera'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_AIRE.webp')
                        },
                        {
                            "Position":"-1.953 5.294 -0.024",
                            "Rotation":"16.645 90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Techo panorámico con apertura de un solo toque'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_TECHO.webp')
                        },
                        {
                            "Position":"-3.826 -0.577 -0.034",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Radio con pantalla táctil de 10,25"', '• USB' , '• Bluetooth' , '• CarPlay & Android Auto', '• Control de A/C'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_VOLANTE-RADIO.webp')
                        },
                        {
                            "Position":"3.931 0.674 -0.0344",
                            "Rotation":"0 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Asientos segunda fila abatible 40 : 20 : 40' , '• Función abatible remota'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_FUNCION ABATIBLE REMOTA .webp')
                        },
                        {
                            "Position":"-3.826 -1.015 2.066",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Control crucero'],
                            "Image":require('./../UI/Bullets/07_Tucson Nx4/04_Tucson NX4 Premium/TucsonNx4_CONTROL CRUCERO.webp')
                        },
                        {
                            "Position":"-3.826 -3.974 0.605",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión: 6 velocidades AT'],
                        },
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-3.826 -0.834 1.065",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "TUCSON NX4 LIMITED INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/Tucson_Limited AT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                    ],
                    "BulletsOn": [
                    ]
                },

                "TUCSON NX4 ATTRACTION INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/Tucson Attraction MT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                    ],
                    "BulletsOn": [
                    ]
                },

                "KONA PREMIUM INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/Kona Premium AT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.728 2.098",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Control de mandos al volante y Bluetooth con reconocimiento de voz.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/KonaPremium_CONTROL DE MANDOS.webp')
                        },
                        {
                            "Position":"-3.765 0.251 0.506",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Radio con pantalla táctil. LCD de 8"', '• USB', '• Bluetooth', '• CarPlay y Android Auto'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/RADIO TACTIL DE.webp')
                        },
                        {
                            "Position":"-3.826 0.120 -0.329",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Conectividad Android Auto y Apple Car Play + Cámara de reversa con guias dinámicas.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/CONECTIVIDAD ANDROID  AUTO Y CARPLAY.webp')
                        },
                        {
                            "Position":"-4.366 -0.684 -5.029",
                            "Rotation":"2.523 -158.705 -18.976",
                            "Scale":"0.15 0.15",
                            "Text":['Seis parlantes, dos en as puertas delanteras, dos en las puertas traseras y dos tweeter'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/PARLANTES.webp')
                        },
                        {
                            "Position":"-5.920 -0.313 -3.879",
                            "Rotation":"2.523 -158.705 -18.976",
                            "Scale":"0.15 0.15",
                            "Text":['Cuenta con 6 bolsas de aire (airbags), como elementos de seguridad interna.']
                        },
                        {
                            "Position":"-5.326 -0.490 3.008",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Sistema de monitoreo de presión de llantas'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/MONITOREO DE PRESION EN LLANTAS.webp')
                        },
                        {
                            "Position":"-4.366 -2.714 0.176",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión de seis velocidades'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/KonaPremium_TRANSMISION DE 6 VELOCID.webp')
                        },
                        {
                            "Position":"-3.778 -1.153 0.092",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Aire acondicionado automático.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/AIRE ACONDICIONADO AUTOMATICO.webp')
                        },
                        {
                            "Position":"-3.249 -6.120 0.690",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Autohold'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/BOTON DE PARQUEO Y AUTOHOLD.webp')
                        },
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-4.326 -1.360 1.311",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "KONA PREMIUM INTERIOR ON": {
                    "Image": require('./../assets/interioresParticulares/Kona Premium AT_Night.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.728 2.098",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Control de mandos al volante y Bluetooth con reconocimiento de voz.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/KonaPremium_CONTROL DE MANDOS.webp')
                        },
                        {
                            "Position":"-3.765 0.251 0.506",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Radio con pantalla táctil. LCD de 8"', '• USB', '• Bluetooth', '• CarPlay y Android Auto'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/RADIO TACTIL DE.webp')
                        },
                        {
                            "Position":"-3.826 0.120 -0.329",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Conectividad Android Auto y Apple Car Play + Cámara de reversa con guias dinámicas.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/CONECTIVIDAD ANDROID  AUTO Y CARPLAY.webp')
                        },
                        {
                            "Position":"-4.366 -0.684 -5.029",
                            "Rotation":"2.523 -158.705 -18.976",
                            "Scale":"0.15 0.15",
                            "Text":['Seis parlantes, dos en as puertas delanteras, dos en las puertas traseras y dos tweeter'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/PARLANTES.webp')
                        },
                        {
                            "Position":"-5.920 -0.313 -3.879",
                            "Rotation":"2.523 -158.705 -18.976",
                            "Scale":"0.15 0.15",
                            "Text":['Cuenta con 6 bolsas de aire (airbags), como elementos de seguridad interna.']
                        },
                        {
                            "Position":"-5.326 -0.490 3.008",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Sistema de monitoreo de presión de llantas'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/MONITOREO DE PRESION EN LLANTAS.webp')
                        },
                        {
                            "Position":"-4.366 -2.714 0.176",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión de seis velocidades'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/KonaPremium_TRANSMISION DE 6 VELOCID.webp')
                        },
                        {
                            "Position":"-3.778 -1.153 0.092",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Aire acondicionado automático.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/AIRE ACONDICIONADO AUTOMATICO.webp')
                        },
                        {
                            "Position":"-3.249 -6.120 0.690",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Autohold'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/BOTON DE PARQUEO Y AUTOHOLD.webp')
                        },
                        
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-4.326 -1.360 1.311",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "KONA LIMITED INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/Kona Limited AT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.728 2.098",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Control de mandos al volante y Bluetooth con reconocimiento de voz.'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/KonaLimited_CONTROL DE MANDOS.webp')
                        },
                        {
                            "Position":"-3.826 0.120 -0.329",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Radio con pantalla táctil. LCD de 8"', '• USB', '• Bluetooth', '• CarPlay y Android Auto'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/KonaLimited_RADIO TACTIL DE.webp')
                        },
                        {
                            "Position":"-4.366 -0.684 -5.029",
                            "Rotation":"2.523 -158.705 -18.976",
                            "Scale":"0.15 0.15",
                            "Text":['Seis parlantes, dos en as puertas delanteras, dos en las puertas traseras y dos tweeter'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/PARLANTES.webp')
                        },
                        {
                            "Position":"-4.826 -0.928 1.798",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Levas en el timón'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/CAMBIOS EN EL VOLANTE.webp')
                        },
                        {
                            "Position":"-4.366 -2.714 0.176",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión de seis velocidades'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/KonaLimited_TRANSMISION DE 6 VELOCIDADES.webp')
                        },
                        {
                            "Position":"-3.449 -6.020 0.890",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Autohold'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/BOTON DE PARQUEO Y AUTOHOLD.webp')
                        },
                        {
                            "Position":"2.449 4.522 -0.085",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Sunroof'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/SUNROOF.webp')
                        },
                        {
                            "Position":"-5.326 -0.490 3.008",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Sistema de monitoreo de presión de llantas'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/MONITOREO DE PRESION EN LLANTAS.webp')
                        },
                        {
                            "Position":"-5.920 -0.760 1.990",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Tablero de instrumentos supervisión 10,25" LCD TFT + Reostato'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/tableroDeInstrumentos.webp')
                        },
                        {
                            "Position":"-3.778 -1.153 0.092",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Aire acondicionado automático.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/AIRE ACONDICIONADO AUTOMATICO.webp')
                        },
                        {
                            "Position":"1.198 -0.816 4.912",
                            "Rotation":"50 -22 0",
                            "Scale":"0.15 0.15",
                            "Text":['Airbag Lateral'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/AIRBAG LATERAL.webp')
                        },
                        {
                            "Position":"1.993 -1.693 -4.509",
                            "Rotation":"5 10 0",
                            "Scale":"0.15 0.15",
                            "Text":['Cojinería en Cuero'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/SILLAS EN CUERO.webp')
                        },
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-4.366 -1.360 1.411",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "KONA LIMITED INTERIOR ON": {
                    "Image": require('./../assets/interioresParticulares/Kona Limited AT_Night.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.728 2.098",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Control de mandos al volante y Bluetooth con reconocimiento de voz.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/KonaPremium_CONTROL DE MANDOS.webp')
                        },
                        {
                            "Position":"-3.826 0.120 -0.329",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Radio con pantalla táctil. LCD de 8"', '• USB', '• Bluetooth', '• CarPlay y Android Auto'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/KonaPremium_RADIO TACTIL DE.webp')
                        },
                        {
                            "Position":"-4.366 -0.684 -5.029",
                            "Rotation":"2.523 -158.705 -18.976",
                            "Scale":"0.15 0.15",
                            "Text":['Seis parlantes, dos en as puertas delanteras, dos en las puertas traseras y dos tweeter'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/KonaPremium_PARL.webp')
                        },
                        {
                            "Position":"-4.366 -2.714 0.176",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión de seis velocidades'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/KonaPremium_TRANSMISION DE 6 VELOCID.webp')
                        },
                        {
                            "Position":"-4.826 -0.928 1.798",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Levas en el timón'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/CAMBIOS EN EL VOLANTE.webp')
                        },
                        {
                            "Position":"-3.449 -6.020 0.890",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Autohold'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/BOTON DE PARQUEO Y AUTOHOLD.webp')
                        },
                        {
                            "Position":"2.449 4.522 -0.085",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Sunroof'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/SUNROOF.webp')
                        },
                        {
                            "Position":"-5.326 -0.490 3.008",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Sistema de monitoreo de presión de llantas'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/MONITOREO DE PRESION EN LLANTAS.webp')
                        },
                        {
                            "Position":"-3.778 -1.153 0.092",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Aire acondicionado automático.'],
                            "Image":require('./../UI/Bullets/06_Kona - Premium/AIRE ACONDICIONADO AUTOMATICO.webp')
                        },
                        {
                            "Position":"-5.920 -0.760 1.990",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Tablero de instrumentos supervisión 10,25" LCD TFT + Reostato'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/tableroDeInstrumentos.webp')
                        },
                        {
                            "Position":"1.198 -0.816 4.912",
                            "Rotation":"50 -22 0",
                            "Scale":"0.15 0.15",
                            "Text":['Airbag Lateral'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/AIRBAG LATERAL.webp')
                        },
                        {
                            "Position":"1.993 -1.693 -4.509",
                            "Rotation":"5 10 0",
                            "Scale":"0.15 0.15",
                            "Text":['Cojinería en Cuero'],
                            "Image":require('./../UI/Bullets/06_Kona - Limited/SILLAS EN CUERO.webp')
                        },
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-4.366 -1.360 1.411",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "VENUE PREMIUM MT INTERIOR": {
                    "Image": require('./../assets/interioresParticulares/Venue MT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.120 -0.329",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Pantalla 8” táctil', '• Android Auto y CarPlay', '• Bluetooth con reconocimiento de voz', '• USB'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Venue_Pantalla.webp')
                        },
                        {
                            "Position":"-3.826 -0.190 -1.183",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Aire acondicionado'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Venue_AIRE.webp')
                        },
                        {
                            "Position":"-3.826 -3.228 0.134",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión MT de 6 velocidades (Premium)'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Venue_cambios.webp')
                        },
                        {
                            "Position":"-3.826 -1.336 3.359",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Cuenta con 6 bolsas de aire (airbags), como elementos de seguridad interna.'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Airbags.webp')
                        },
                        {
                            "Position":"-3.826 -0.728 2.098",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Controles de mando en el volante'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Venue_CONTROLES.webp')
                        }
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-4.366 -1.557 1.159",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "VENUE PREMIUM MT INTERIOR ON": {
                    "Image": require('./../assets/interioresParticulares/Venue MT_Night.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.120 -0.329",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['• Pantalla 8” táctil', '• Android Auto y CarPlay', '• Bluetooth con reconocimiento de voz', '• USB'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Venue_Pantalla.webp')
                        },
                        {
                            "Position":"-3.826 -0.190 -1.183",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Aire acondicionado'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Venue_AIRE.webp')
                        },
                        {
                            "Position":"-3.826 -3.228 0.134",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Transmisión MT de 6 velocidades (Premium)'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Venue_cambios.webp')
                        },
                        {
                            "Position":"-3.826 -1.336 3.359",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Cuenta con 6 bolsas de aire (airbags), como elementos de seguridad interna.'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Airbags.webp')
                        },
                        {
                            "Position":"-3.826 -0.728 2.098",
                            "Rotation":"41.000 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":['Controles de mando en el volante'],
                            "Image":require('./../UI/Bullets/08_Venue/Venue_Venue_CONTROLES.webp')
                        }
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-4.366 -1.557 1.159",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "SUPER METRO ACCENT INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/SuperMetro_Accent.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.580 -0.007",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Pantalla táctil doble DIN/USB/AUX"],
                        },
                        {
                            "Position":"-3.826 -2.038 0.192",
                            "Rotation":"0 90 0",
                            "Scale":"0.2 0.2",
                            "Text":["Aire acondicionado"],
                        },
                        {
                            "Position":"-3.826 -4.290 0.315",
                            "Rotation":"55 -90 0",
                            "Scale":"0.2 0.2",
                            "Text":["Transmisión: 5MT"],
                        },
                        {
                            "Position":"-3.826 0.834 2.510",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Dirección electroasistida (MDPS)"],
                        },
                        {
                            "Position":"-3.826 -0.522 2.689",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Control de mandos en el volante"],
                        },
                        {
                            "Position":"-3.826 -1.135 4.123",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Bolsas de aire (airbags) frontales"],
                        },
                        {
                            "Position":"-2.752 -2.103 5.929",
                            "Rotation":"74.232 -90 0",
                            "Scale":"0.2 0.2",
                            "Text":["Vidrios eléctricos delanteros y traseros"],
                        },
                    ]
                },

                "GRAND METRO HB INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/Grand_ i10_Hatchback.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.472 -0.177",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Pantalla táctil doble DIN/USB/AUX"],
                        },
                        {
                            "Position":"-3.826 -0.457 -0.222",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Aire acondicionado"],
                        },
                        {
                            "Position":"-3.826 -1.471 -0.239",
                            "Rotation":"55 -90 0",
                            "Scale":"0.2 0.2",
                            "Text":["Transmisión: 5MT"],
                        },
                        {
                            "Position":"-3.826 0.983 1.320",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Dirección electroasistida (MDPS)"],
                        },
                        {
                            "Position":"-3.826 -0.066 1.407",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Control de mandos en el volante"],
                        },
                        {
                            "Position":"-3.826 -0.620 2.256",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Bolsas de aire (airbags) frontales"],
                        },
                        {
                            "Position":"-3.638 -2.103 5.123",
                            "Rotation":"74.232 -90 0",
                            "Scale":"0.2 0.2",
                            "Text":["Vidrios eléctricos delanteros y traseros"],
                        },
                    ]
                },

                "GRAND METRO SEDAN INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/Grand_i10_Sedan.webp'),
                    "Rotation":"0 90 0"
                    ,
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 0.744 0.110",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Pantalla táctil doble DIN/USB/AUX"],
                        },
                        {
                            "Position":"-3.826 -0.291 0.086",
                            "Rotation":"0 90 0",
                            "Scale":"0.1 0.1",
                            "Text":["Aire acondicionado"],
                        },
                        {
                            "Position":"-3.826 -1.461 0.234",
                            "Rotation":"55 -90 0",
                            "Scale":"0.2 0.2",
                            "Text":["Transmisión: 5MT"],
                        },
                        {
                            "Position":"-3.826 0.983 1.844",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Dirección electroasistida (MDPS)"],
                        },
                        {
                            "Position":"-3.826 0.277 2.237",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Control de mandos en el volante"],
                        },
                        {
                            "Position":"-3.826 -0.620 3.533",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Bolsas de aire (airbags) frontales"],
                        },
                        {
                            "Position":"-2.896 -2.103 6.571",
                            "Rotation":"74.232 -90 0",
                            "Scale":"0.2 0.2",
                            "Text":["Vidrios eléctricos delanteros y traseros"],
                        },
                    ]
                },

                "HD78 INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/Camion_HD65.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.950 1.844",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Interruptor freno de ahogo"],
                        },
                        {
                            "Position":"-3.826 -3.632 2.237",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Embrague hidraulico con suavizador"],
                        },
                        {
                            "Position":"-3.826 -1.468 4.850",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Acelerador manual"],
                        }
                    ]
                },

                "HD65 INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/Camion_HD65.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.950 1.844",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Interruptor freno de ahogo"],
                        },
                        {
                            "Position":"-3.826 -3.632 2.237",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Embrague hidraulico con suavizador"],
                        },
                        {
                            "Position":"-3.826 -1.468 4.850",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Acelerador manual"],
                        }
                    ]
                },

                "HD55 INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/Camion_HD65.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.950 1.844",
                            "Rotation":"0 90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Interruptor freno de ahogo"],
                        },
                        {
                            "Position":"-3.826 -3.632 2.237",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Embrague hidraulico con suavizador"],
                        },
                        {
                            "Position":"-3.826 -1.468 4.850",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Acelerador manual"],
                        }
                    ]
                },

                "STARIA INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/StariaMT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.732 3.657",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Control de mandos en el volante"],
                        },
                        {
                            "Position":"-3.826 0.982 2.237",
                            "Rotation":"0 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Panel LCD en color de 4,2 pulgadas (estándar): Refleja el diseño del clúster digital utilizando una pantalla LCD de segmento completo y aplica la función de conversión de color de decoración para cada modo de conducción."],
                        },
                        {
                            "Position":"-3.826 0.528 -0.273",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["• Radio", "• Bluetooth", "• USB"],
                        }
                    ]
                },

                "STARIA BAUL": {
                    "Image": require('./../assets/InterioresComerciales/StariaMT_Day-Baul.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                    ]
                },

                "STARIA PASAJEROS INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/StariaMT_Day.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.732 3.657",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Control de mandos en el volante"],
                        },
                        {
                            "Position":"-3.826 0.982 2.237",
                            "Rotation":"0 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Panel LCD en color de 4,2 pulgadas (estándar): Refleja el diseño del clúster digital utilizando una pantalla LCD de segmento completo y aplica la función de conversión de color de decoración para cada modo de conducción."],
                        },
                        {
                            "Position":"-3.826 0.528 -0.273",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["• Radio", "• Bluetooth", "• USB"],
                        },
                        {
                            "Position":"-2.650 -0.739 3.997",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Bolsas de aire (airbags) frontales (Conductor + Pasajero)."],
                        },
                        {
                            "Position":"-5.008 0.051 -5.513",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Aire acondicionado"],
                        }
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-3.826 -1.089 2.594",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "STARIA PASAJEROS BAUL": {
                    "Image": require('./../assets/InterioresComerciales/StariaMT_Day-Baul.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                    ],
                    "BulletsOn": [
                    ]
                },

                "STARIA PASAJEROS INTERIOR ON": {
                    "Image": require('./../assets/interioresParticulares/StariaMT_Night.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                        {
                            "Position":"-3.826 -0.732 3.657",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Control de mandos en el volante"],
                        },
                        {
                            "Position":"-3.826 0.982 2.237",
                            "Rotation":"0 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["Panel LCD en color de 4,2 pulgadas (estándar): Refleja el diseño del clúster digital utilizando una pantalla LCD de segmento completo y aplica la función de conversión de color de decoración para cada modo de conducción."],
                        },
                        {
                            "Position":"-3.826 0.528 -0.273",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                            "Text":["• Radio", "• Bluetooth", "• USB"],
                        }
                    ],
                    "BulletsOn": [
                        {
                            "Position":"-3.826 -1.089 2.594",
                            "Rotation":"41.255 -90 0",
                            "Scale":"0.15 0.15",
                        }
                    ]
                },

                "EX8 INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/EX8.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                    ]
                },

                "EX10 INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/EX10.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                    ]
                },

                "GRAND METRO TAXI INTERIOR": {
                    "Image": require('./../assets/InterioresComerciales/GrandI10.webp'),
                    "Rotation":"0 90 0",
                    "BulletsInfo":[
                    ]
                },
            }
        ]
    }
}